import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slicers/authSlicer";
import { useTranslation } from "react-i18next";

const isDarkModeActive = () => {
  if (typeof window !== 'undefined') {
    return document.documentElement.classList.contains('dark');
  }
  return false;
};

const Unauthorized = () => {
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDark(isDarkModeActive());
    };
    
    checkDarkMode();
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          checkDarkMode();
        }
      });
    });
    
    observer.observe(document.documentElement, { attributes: true });
    
    return () => observer.disconnect();
  }, []);

  console.log(user, "this is user for dasf");
  const userAccountType = user?.agentDetail?.accountType || user?.accountType || user?.role;
  const customerRole = user?.roleName || user?.roleData?.name;
  console.log(customerRole, "this is customer role");
  const effectiveRole = userAccountType || customerRole;
  console.log(effectiveRole, "this is effective role");

  const handleRedirect = () => {
    if (effectiveRole === "b2c") {
      navigate("/coming-soon");
    } else if (["merchant", "retailer", "b2b"].includes(effectiveRole)) {
      navigate("/");
    } else {
      navigate("/signin");
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate("/signin");
  };

  return (
    <div className={`min-h-screen flex items-center justify-center p-4 transition-colors duration-300 ${
      isDark 
        ? 'bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900' 
        : 'bg-gray-100'
    }`}>
      <div className={`max-w-md w-full p-8 rounded-lg shadow-md text-center transition-colors duration-300 ${
        isDark 
          ? 'bg-gray-800 border border-gray-700' 
          : 'bg-white'
      }`}>
        {/* <div className="flex justify-center mb-6">
          <div className={`w-20 h-20 rounded-full flex items-center justify-center ${
            isDark ? 'bg-red-900/30' : 'bg-red-100'
          }`}>
            <svg
              className={`w-10 h-10 ${isDark ? 'text-red-400' : 'text-red-600'}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 15v2m0 0v2m0-2h2m-2 0H9m6-6a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div> */}

        <h1 className={`text-2xl font-bold mb-4 transition-colors duration-300 ${
          isDark ? 'text-red-400' : 'text-red-600'
        }`}>
          {t('unauthorized.title')}
        </h1>
        
        <p className={`mb-6 transition-colors duration-300 ${
          isDark ? 'text-gray-300' : 'text-gray-600'
        }`}>
          {t('unauthorized.message')}
        </p>

        {effectiveRole && (
          <div className={`mb-6 p-3 rounded-md text-sm transition-colors duration-300 ${
            isDark 
              ? 'bg-gray-700 text-gray-300' 
              : 'bg-gray-100 text-gray-600'
          }`}>
            <span className="font-semibold">{t('unauthorized.yourRole')}: </span>
            <span className="uppercase">{effectiveRole}</span>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleLogout}
            className="w-full px-6 py-3 bg-gradient-to-r from-primary to-[#ec68b5] text-white rounded-lg hover:shadow-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {t('unauthorized.signOut')}
          </button>

          {/* <button
            onClick={handleLogout}
            className={`w-full px-6 py-3 rounded-lg transition-all duration-300 transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
              isDark
                ? 'bg-gray-700 text-gray-200 hover:bg-gray-600 focus:ring-gray-500'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300 focus:ring-gray-400'
            }`}
          >
            {t('unauthorized.signOut')}
          </button> */}
        </div>

        <p className={`mt-6 text-xs transition-colors duration-300 ${
          isDark ? 'text-gray-500' : 'text-gray-400'
        }`}>
          {t('unauthorized.helpText')}
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;